import { reactive } from 'vue';
import AuthCookie from '../../../services/AuthCookie';
import { Auth, AuthKey, AuthUser } from '../types/auth.types';

export default <User extends AuthUser>(authKey: AuthKey): Auth<User> => {
  const authCookieName = `${authKey}-auth`;
  const authUserName = `${authKey}-user`;
  const authCookie = AuthCookie(authCookieName);

  const userState: {
    user: User | null;
    setUser(user: User | null): void;
  } = reactive({
    user: null,
    setUser(user: User | null) {
      this.user = user;
    },
  });

  function isAuthenticated(): boolean {
    return !!authCookie.get();
  }

  function setUser(newUser: User | null) {
    if (newUser) {
      localStorage.setItem(authUserName, JSON.stringify(newUser));
      authCookie.set();
      userState.setUser({ ...newUser });
    } else {
      localStorage.removeItem(authUserName);
      authCookie.remove();
      userState.setUser(null);
    }
  }
  function getUser(): User | null {
    return userState.user;
  }

  function refreshLogin() {
    setUser(JSON.parse(localStorage.getItem(authUserName)) ?? null);
  }

  refreshLogin();

  return {
    isAuthenticated,
    setUser,
    getUser,
    refreshLogin,
  };
};
